$(function () {

  var mobileButton = $('.mobile-nav');
  var mobileCloseSidebar = $('.closeable');
  var directoriesBlock = $('.directories-block');
  var sideBar = $('.wrapper-sidebar');
  var keys = {
    37: 1,
    38: 1,
    39: 1,
    40: 1
  };
  var _body = $('body');

  mobileButton.on('click', function () {
    sideBar.addClass('is-open');
    disableScroll();
    toggleBodyClass()
  });

  mobileCloseSidebar.on('click', function () {
    sideBar.removeClass('is-open');
    directoriesBlock.removeClass('active');
    enableScroll();
    toggleBodyClass()
  });

  $('.wrapper-sidebar #mobile-trigger').on('click', function (e) {
    e.preventDefault();
    directoriesBlock.addClass('active');
  });

  $('.wrapper-sidebar #turn-back').on('click', function (e) {
    e.preventDefault();
    directoriesBlock.removeClass('active');
  });

  function toggleBodyClass() {
    _body.toggleClass('sidebar-is-open')
  }

  function preventDefault(e) {
    e = e || window.event;
    if (e.preventDefault) {
      e.preventDefault();
    }
    e.returnValue = false;
  }

  function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
      preventDefault(e);
      return false;
    }
  }

  function disableScroll() {
    if (window.addEventListener) {
      window.addEventListener('DOMMouseScroll', preventDefault, false);
    }
    window.onwheel = preventDefault;
    window.onmousewheel = document.onmousewheel = preventDefault;
    window.ontouchmove = preventDefault;
    document.onkeydown = preventDefaultForScrollKeys;
  }

  function enableScroll() {
    if (window.removeEventListener) {
      window.removeEventListener('DOMMouseScroll', preventDefault, false);
    }
    window.onmousewheel = document.onmousewheel = null;
    window.onwheel = null;
    window.ontouchmove = null;
    document.onkeydown = null;
  }
});


// WEBPACK FOOTER //
// ./app/webpacker/src/js/mobile_actions.js